<div class="content">
  <glxy-form-field>
    <mat-radio-button [checked]="true">
      {{ 'AUTOMATIONS.EDITOR.TASKS.ASSOCIATE_COMPANY_WITH_CONTACT.PRIMARY_SELECT' | translate }}
    </mat-radio-button>
  </glxy-form-field>
  <glxy-form-field>
    <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.ASSOCIATE_COMPANY_WITH_CONTACT.TITLE_TAGS' | translate }}</glxy-label>
    <extended>{{ 'AUTOMATIONS.EDITOR.TASKS.ASSOCIATE_COMPANY_WITH_CONTACT.DESCRIPTION_TAGS' | translate }}</extended>
    <glxy-tags-input [uniqueTags]="true" [autocompleteOnly]="false" [formControl]="tags" />
  </glxy-form-field>
</div>
